export default __webpack_public_path__ + "static/media/branding.a7093439.svg";